import type { SkeletonProps } from '@mui/material';
import { Skeleton as MUISkeleton } from '@mui/material';

export default function Skeleton(props?: SkeletonProps) {
  return <MUISkeleton animation="wave" {...props} />;
}
